// НИША В LOCAL STORAGE (бэклог «Портрет клиента 2026-08-31»: «нишу держать в local
// storage: разлогинился — мы её помним и показываем персональные примеры даже снаружи»).
//
// INVARIANT(scriptera): любое чтение и запись local storage — в try/catch, и страница
// обязана работать без него. Причина: приватное окно, отключённые куки-и-данные сайта и
// переполненная квота бросают исключение прямо на доступе к localStorage, а виджеты
// примеров стоят на ГЛАВНОЙ — уронить их нельзя ничем.

/** Что человек подтвердил (или что мы про него знаем). */
const NICHE_KEY = 'scriptera-niche';
/** Счётчик заходов для ротации: пусто в памяти — каждый заход показываем новую нишу. */
const ROTATION_KEY = 'scriptera-niche-rot';

/** Ниша, запомненная на устройстве. Пусто/недоступно — null. */
export function readNicheLocal(): string | null {
  try {
    const v = localStorage.getItem(NICHE_KEY);
    return v && v.trim() ? v.trim() : null;
  } catch {
    return null;
  }
}

/** Запомнить нишу на устройстве. Недоступно — молча живём дальше. */
export function writeNicheLocal(key: string | null | undefined): void {
  try {
    if (key && key.trim()) localStorage.setItem(NICHE_KEY, key.trim());
    else localStorage.removeItem(NICHE_KEY);
  } catch {
    /* хранилища нет — примеры просто останутся общими */
  }
}

/** Следующий номер в ротации. Чистая — юниты. */
export function nextRotationIndex(prev: number | null, len: number): number {
  if (len <= 0) return 0;
  const base = Number.isFinite(prev) && prev !== null && prev >= 0 ? Math.floor(prev) : -1;
  return (base + 1) % len;
}

/**
 * КАКУЮ НИШУ ПОКАЗАТЬ СНАРУЖИ. Знаем человека — его; не знаем — каждый заход новую по
 * кругу (владелец 31.08). Счётчик круга живёт там же, в local storage; хранилища нет —
 * берём случайную, лишь бы примеры не были одинаковыми у всех.
 */
export function pickNicheForVisit(keys: readonly string[]): string | null {
  if (keys.length === 0) return null;
  const mine = readNicheLocal();
  if (mine && keys.includes(mine)) return mine;
  try {
    const raw = localStorage.getItem(ROTATION_KEY);
    const next = nextRotationIndex(raw === null ? null : Number(raw), keys.length);
    localStorage.setItem(ROTATION_KEY, String(next));
    return keys[next] ?? null;
  } catch {
    return keys[Math.floor(Math.random() * keys.length)] ?? null;
  }
}
